const same = (a, b) => JSON.stringify(a) === JSON.stringify(b);

// These results can arrive while the electrical save awaits catalogue data or
// string mapping. They do not change the electrical design being validated.
const horizonKeys = ["horizonProfile", "horizonProfileSite"];
function inputs(config, derivedCapacity) {
  const result = { ...config, panelOrientation: { ...config?.panelOrientation } };
  delete result.orientationOptimization;
  horizonKeys.forEach(key => delete result.panelOrientation[key]);
  if (derivedCapacity) {
    result.pvInstalledCap = { ...config?.pvInstalledCap };
    delete result.pvInstalledCap.kw;
  }
  return result;
}

export function electricalSaveError(message) {
  return Object.assign(new Error(message), { userMessage: message });
}

export function electricalSaveConflict(greek) {
  return electricalSaveError(greek
    ? "Τα στοιχεία σχεδιασμού άλλαξαν κατά την αποθήκευση. Ελέγξτε το σχέδιο και αποθηκεύστε ξανά."
    : "Design inputs changed while saving. Review the design and save again.");
}

export function mergeElectricalSaveSnapshot(before, proposed, latest, greek = false) {
  // With an existing design the capacity field is derived from its modules.
  // The first auto-design can also update it to exactly the capacity being
  // saved. Any other change to an unsaved project's target stays protected.
  const proposedKw = Number(proposed?.pvInstalledCap?.kw);
  const derivedCapacity = Boolean(before?.systemDesign && Object.keys(before.systemDesign).length) ||
    (Number.isFinite(proposedKw) && proposedKw > 0 && Number(latest?.pvInstalledCap?.kw) === proposedKw);
  if (!same(inputs(before, derivedCapacity), inputs(latest, derivedCapacity))) {
    throw electricalSaveConflict(greek);
  }
  const merged = { ...proposed };
  const copyLatest = (target, source, key) => {
    if (Object.prototype.hasOwnProperty.call(source || {}, key)) target[key] = source[key];
    else delete target[key];
  };
  if (!same(before?.orientationOptimization, latest?.orientationOptimization)) {
    copyLatest(merged, latest, "orientationOptimization");
  }
  horizonKeys.forEach(key => {
    if (!same(before?.panelOrientation?.[key], latest?.panelOrientation?.[key])) {
      merged.panelOrientation = { ...merged.panelOrientation };
      copyLatest(merged.panelOrientation, latest?.panelOrientation, key);
    }
  });
  return merged;
}
